'use client';
import React from 'react';
import { Link } from '@/i18n/navigation';

const LocaleLink = ({ href, children, ...props }) => {
  // 检查是否为外部链接
  const isExternal = href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:') || href.startsWith('tel:');

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  // 使用next-intl的Link组件，它会自动处理语言前缀
  return (
    <Link href={href} {...props}>
      {children}
    </Link>
  );
};

export default LocaleLink;